export enum CallDirectionType
{
    Inbound = 1,
    Outbound = 2
}